import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import {
  loadImportantNotification,
  updateImportantNotificationConfirm,
  updateImportantNotificationRead
} from '../actions/important-notification-dialog-actions';
import { Button } from '@progress/kendo-react-buttons';
import styled from 'styled-components';

const RawHtmlContent = styled.div`
  max-width: 80vw;
  max-height: 70vh;
`;

class ImportantNotificationDialog extends React.PureComponent {

  constructor() {
    super();
  }

  async componentDidMount() {
    this.props.loadNotification();
  }

  render() {
    const localizationService = provideLocalizationService(this);
    const { loading, notification, visible } = this.props;
    return (visible && notification &&
      <>
        <Dialog
          title={notification.title}
          loading={loading}
          onClose={() => this.props.readNotification({ notificationId: notification.id })}
          className='important-notification-dialog'
          minWidth={320}
        >
          <RawHtmlContent
            ref={this.updateNotificationAnchors}
            dangerouslySetInnerHTML={{ __html: notification.text }}
          >
          </RawHtmlContent>
          <DialogActionsBar>
            <Button
              disabled={loading}
              onClick={() => this.props.readNotification({ notificationId: notification.id })}
            >
              {localizationService.toLanguageString('buttons.close')}
            </Button>
            <Button
              themeColor='primary'
              disabled={loading}
              onClick={() => this.props.confirmNotification({ notificationId: notification.id })}
            >
              {localizationService.toLanguageString('notifications.doNotShowAgain')}
            </Button>
          </DialogActionsBar>
        </Dialog>
        {this.props.loading && this.renderLoader()}
      </>
    );
  }

  updateNotificationAnchors = (element) => {
    element?.querySelectorAll('a').forEach(x => {
      x.rel = 'noopener noreferrer';
      x.target = '_blank';
    });
  };

  renderLoader() {
    const loadingPanel = (
      <div className='k-loading-mask'>
        <div className='k-loading-image' />
        <div className='k-loading-color' />
      </div>
    );
    const dialogContent = document && document.querySelector('.important-notification-dialog');
    return dialogContent
      ? ReactDOM.createPortal(loadingPanel, dialogContent)
      : loadingPanel;
  }
}

registerForLocalization(ImportantNotificationDialog);

const mapStateToProps = state => ({
  visible: state.importantNotificationDialog.visible,
  loading: state.importantNotificationDialog.loading,
  notification: state.importantNotificationDialog.notification
});

const mapDispatchToProps = dispatch => ({
  loadNotification: (payload) => dispatch(loadImportantNotification(payload)),
  confirmNotification: (payload) => dispatch(updateImportantNotificationConfirm(payload)),
  readNotification: (payload) => dispatch(updateImportantNotificationRead(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportantNotificationDialog);
